import React from 'react';

import { cn } from '../../base/utils';

import { SkeletonScope, type SkeletonGroupAnimation } from '../../skeleton/motion';

import { Skeleton } from '../Skeleton';

export interface SkeletonTextProps extends React.HTMLAttributes<HTMLDivElement> {
  animation?: SkeletonGroupAnimation;
  /**
   * 文本行数
   * @default 1
   */
  lines?: number;
  /**
   * 最后一行宽度百分比
   * @default 100
   */
  lastLineWidth?: number;
  /**
   * 行高
   * @default 'md'
   */
  size?: 'sm' | 'md' | 'lg';
  /**
   * 行间距
   * @default 2
   */
  spacing?: number;
}

const sizeMap = {
  sm: 'h-3',
  md: 'h-4',
  lg: 'h-5',
};

/**
 * 文本骨架屏组件
 * 用于文本内容的占位显示
 */
export function SkeletonText({
  className,
  animation,
  lines = 1,
  lastLineWidth = 100,
  size = 'md',
  spacing = 2,
  ...props
}: SkeletonTextProps) {
  return (
    <SkeletonScope animation={animation}>
      <div className={cn('flex flex-col', `gap-${spacing}`, className)} {...props}>
        {Array.from({ length: lines }).map((_, index) => (
          <Skeleton
            key={index}
            className={cn(sizeMap[size], 'w-full')}
            style={{
              width: index === lines - 1 && lastLineWidth !== 100 ? `${lastLineWidth}%` : undefined,
            }}
          />
        ))}
      </div>
    </SkeletonScope>
  );
}
